module.exports = __webpack_public_path__ + "static/media/address_home.0ff8cf80.svg";